import React, { Fragment, useEffect, useState } from "react";
import ModalBox from "../../components/modal/ModalBox";
import { Input, Select, TextArea } from "../../components/Form";
import useButtonLoader from "../../hooks/UseButtonLoader";
import {
  allowAlphaNumericWithSpace,
  optimizeFunction,
  regex,
} from "../../utils/regex";
import { Avatar, Chip, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio } from "@mui/material";
import { charLimit } from "../../utils/charLimit";
import { toastMessage } from "../../utils/toastMessage";
import commonMessages from "../../utils/commonMessages";
import {
  checkImageAspectRatio,
  checkImageDimensions,
  getImageDimension,
} from "../../utils/checkImageDimension";
import { AddExploreApi } from "../../services/exploreManagement";
import VideoPreview from "../../components/videoPreview/VideoPreview";
import VideoThumbnail from "react-video-thumbnail";
import { BaseToImage } from "../../utils/BaseToImage";
import configData from "../../config/configData";
import { convertSecToMin } from "../../utils/convertSecToMin";

// Utility functions for responsive dimensions
const responsiveWidth = (percentage) => `${percentage}%`;
const responsiveHeight = (percentage) => `${percentage}%`;

// Container ratio constants
const CONTAINER_1 = { width: responsiveWidth(45), height: responsiveHeight(40) };
const CONTAINER_2 = { width: responsiveWidth(42), height: responsiveHeight(20) };
const CONTAINER_3 = { width: responsiveWidth(90), height: responsiveHeight(20) };
const CONTAINER_4 = { width: responsiveWidth(42), height: responsiveHeight(20) };

// Container ratio options for dropdown
const containerRatioOptions = [
  { value: "CONTAINER_1", label: "Container 1 (45% × 40%)", ratio: CONTAINER_1 },
  { value: "CONTAINER_2", label: "Container 2 (42% × 20%)", ratio: CONTAINER_2 },
  { value: "CONTAINER_3", label: "Container 3 (90% × 20%)", ratio: CONTAINER_3 },
  { value: "CONTAINER_4", label: "Container 4 (42% × 20%)", ratio: CONTAINER_4 },
];

const { imageFileRegex, videoFileRegex , audioFileRegex } = regex;

const { IMAGE_FORMAT, MESSAGE_SIZE, VIDEO_FORMAT ,VALID_AUDIO,  AUDIO_EXCEED_SIZE,
  EXCEED_SIZE, ERROR_AUDIO_LOADING
 } = commonMessages;

const AddStories = ({ show, close, listing }) => {
  const [storiesValue, setStoriesValue] = useState({});
  const [imageSize, setImageSize] = useState({
    height: "",
    width: "",
  });
  const [videoThumbnail, setVideoThumbnail] = useState(null);
  const [exploreImage, setExploreImage] = useState(null);
  const [image, setImage] = useState([]);
  const [error, setError] = useState({});
  const [buttonref, buttonLoader] = useButtonLoader("Save");
  const [music, setMusic] = useState('')
  const [musicDuration,setMusicDuration]=useState("");
  const [selectedContainerRatio, setSelectedContainerRatio] = useState("");
  const [postType, setPostType] = useState("image");
  const [scheduledAt, setScheduledAt] = useState("");
  const [isScheduled, setIsScheduled] = useState(false);

  //----------vaidation------------
  const validation = () => {
    let errorMessage = {};
    let status = true;

    if (!storiesValue.title) {
      errorMessage["title"] = "Please enter title";
      status = false;
    }

    if (!storiesValue.hastag) {
      errorMessage["hastag"] = "Add hashtag ";
      status = false;
    }
    if (!storiesValue.description) {
      errorMessage["description"] = "Add description";
      status = false;
    }
    if (!selectedContainerRatio) {
      errorMessage["containerRatio"] = "Please select container ratio";
      status = false;
    }

    // Post type specific validation
    if (postType === "image" && image.length === 0) {
      errorMessage["image"] = "Please add at least one image";
      status = false;
    }
    
    if (postType === "audio" && (!music || image.length === 0)) {
      if (!music) errorMessage["music"] = "Please add audio file";
      if (image.length === 0) errorMessage["image"] = "Please add at least one image";
      status = false;
    }
    
    if (postType === "video" && image.length === 0) {
      errorMessage["image"] = "Please add at least one video";
      status = false;
    }

    // Schedule validation
    if (isScheduled && !scheduledAt) {
      errorMessage["scheduledAt"] = "Please select schedule date and time";
      status = false;
    }

    if (isScheduled && scheduledAt && new Date(scheduledAt) <= new Date()) {
      errorMessage["scheduledAt"] = "Schedule date must be in the future";
      status = false;
    }

    setError(errorMessage);
    return status;
  };

  // Add Stories media handler
  const imageHandler = async (e) => {
    e.preventDefault();
    const { files } = e.target;
    console.log(files, "Files");

    if (files.length === 0) {
      return;
    }

    // Convert FileList to Array for easier handling
    const fileArray = Array.from(files);
    const validFiles = [];
    const invalidFiles = [];

    for (const file of fileArray) {
      const fileName = file.name.toLowerCase();
      const isGif = fileName.endsWith(".gif");
      const isImage = imageFileRegex.test(fileName);
      const isVideo = videoFileRegex.test(fileName);

      if (isGif || isImage || isVideo) {
        if (isGif) {
          const validAspectRatio = await checkImageAspectRatio(file);
          if (validAspectRatio) {
            validFiles.push(file);
          } else {
            invalidFiles.push(file.name);
          }
        } else if (isImage) {
          validFiles.push(file);
          // Get dimensions for the first image
          if (image.length === 0 && validFiles.length === 1) {
            const img = await getImageDimension(file);
            setImageSize(img);
          }
        } else if (isVideo) {
          validFiles.push(file);
        }
      } else {
        invalidFiles.push(file.name);
      }
    }

    if (invalidFiles.length > 0) {
      toastMessage(
        `Invalid format for: ${invalidFiles.join(", ")}. Only GIF, images and videos supported`,
        "error",
        "InvalidFormat"
      );
    }

    if (validFiles.length > 0) {
      // Add new files to existing images
      setImage(prevImages => [...prevImages, ...validFiles]);
    }
    
    // Clear the input so user can select same file again if needed
    e.target.value = "";
  };

  const clearInputAndImageState = (e) => {
    e.target.value = "";
    setImage([]);
  };

  // Remove individual image
  const removeImage = (indexToRemove) => {
    setImage(prevImages => prevImages.filter((_, index) => index !== indexToRemove));
  };

  console.log(imageSize, "ImageSize");

  //------------------onChange-input-value---------------------------
  const handleChange = (e) => {
    const { name, value } = e.target;
    let updatedValue = value;
    if (name === "title") {
      updatedValue = allowAlphaNumericWithSpace(value);
    }
    setStoriesValue({ ...storiesValue, [name]: updatedValue });
  };

  //------------------modal-close--------------------------
  const modalClose = () => {
    setImage("");
    setStoriesValue({ title: "", categoryId: "" });
    setSelectedContainerRatio("");
    setPostType("image");
    setScheduledAt("");
    setIsScheduled(false);
    setMusic("");
    setMusicDuration("");
    setVideoThumbnail(null);
    setExploreImage(null);
    setError({});
    close();
  };
 
  //-------------Add Music--------------------------------

  const resetInputAndMusic = (e) => {
    e.target.value = ''
    setMusic('')
  }

  const audioHandler = (e) => {
    e.preventDefault()

    const maxSizeInBytes = configData.audio_legth
    const maxDurationInSeconds = configData.audio_duration
    const file = e.target?.files[0]

    if (!file) {
      resetInputAndMusic(e)
      return
    }

    if (!audioFileRegex.test(file.name)) {
      resetInputAndMusic(e)
      toastMessage(VALID_AUDIO, 'error', 'addAudio')
      return
    }

    if (file.size > maxSizeInBytes) {
      resetInputAndMusic(e)
      toastMessage(EXCEED_SIZE, 'error', 'addAudio')
      return
    }

    const audioElement = document.createElement('audio')
    audioElement.src = URL.createObjectURL(file)
    audioElement.onloadedmetadata = () => {
      if (audioElement.duration > maxDurationInSeconds) {
        resetInputAndMusic(e)
        toastMessage(AUDIO_EXCEED_SIZE, 'error', 'addAudio')
      } else {
        setMusicDuration(convertSecToMin(audioElement.duration));
        setMusic(file)
      }
    }
    audioElement.onerror = () => {
      resetInputAndMusic(e)
      toastMessage(ERROR_AUDIO_LOADING, 'error', 'addAudio')
    }
  }



  //--------------Add-story------------------------
  const addStoriesHandler = async () => {
    const status = validation();
    // console.log(status, "status");
    if (status) {
      try {
        buttonLoader(true);
        const formData = new FormData();
        formData.append("title", storiesValue.title);
        formData.append("hastag", storiesValue.hastag);
        formData.append("description", storiesValue.description);
        formData.append("postType", postType);
        
        // Add scheduling data
        if (isScheduled && scheduledAt) {
          formData.append("scheduledAt", scheduledAt);
          formData.append("isScheduled", "true");
        } else {
          formData.append("isScheduled", "false");
        }
        
        // Add container ratio data
        const selectedOption = containerRatioOptions.find(option => option.value === selectedContainerRatio);
        if (selectedOption) {
          formData.append("containerRatio", selectedContainerRatio);
          formData.append("containerWidth", selectedOption.ratio.width);
          formData.append("containerHeight", selectedOption.ratio.height);
        }
        
        if (videoThumbnail) {
          formData.append("videoThumbnail", BaseToImage(videoThumbnail));
        }
        if(exploreImage){
          formData.append("exploreImage",exploreImage);
        }
        if(imageSize?.height && imageSize?.width){
          formData.append("heigth", imageSize?.height);
          formData.append("width", imageSize?.width);
        }
        if(music){
          formData.append("exploreAudio",music)
        }
        image.forEach((element) => {
          formData.append("exploreMedia", element);
        });
        console.log('formData : ', formData);
        const { data } = await AddExploreApi(formData);
        if (data.code === 200) {
          toastMessage(data.message, "success", "addStory");
          listing();
          modalClose();
        } else {
          toastMessage(data.message, "error", "addStory");
        }
      } catch (error) {
        console.log("error", error);
      } finally {
        buttonLoader(false);
      }
    }
  };

  // console.log(image, "image");

  return (
    <ModalBox
      status={show}
      onClose={modalClose}
      title={"Add Story"}
      closeIcon
      size={"sm"}
      custom
      customizedFooter={
        <div className="model_custom_footer">
          {/* <p>{MESSAGE_SIZE}</p> */}
          <button
            className="btn_size "
            ref={buttonref}
            onClick={addStoriesHandler}
          >
            Save
          </button>
        </div>
      }
    >
      <div>
        <div className="form-group mb-2">
          <Input
            type="text"
            name="title"
            value={storiesValue?.title || ""}
            required
            onChange={(e) => handleChange(e)}
            placeholder=" Title"
            className={`form-control `}
            label={"Title"}
            error={!storiesValue.title && error.title}
            maxLength={30}
          />
        </div>
        <div className="form-group mb-2">
          <Input
            name="hastag"
            type="text"
            placeholder="Hashtag"
            value={storiesValue?.hastag || ""}
            onChange={(e) => handleChange(e)}
            required
            className="form-control"
            label="Hashtag"
            error={!storiesValue.hastag && error.hastag}
          />
        </div>

        <div className="form-group mb-2">
          <TextArea
            name="description"
            type="text"
            placeholder="Write here..."
            value={storiesValue?.description || ""}
            onChange={(e) => handleChange(e)}
            required
            className="form-control"
            label="Description"
            error={!storiesValue.description && error.description}
          />
        </div>

        {/* Post Type Selection */}
        <div className="form-group mb-2">
          <FormControl component="fieldset">
            <FormLabel component="legend">Post Type</FormLabel>
            <RadioGroup
              row
              value={postType}
              onChange={(e) => setPostType(e.target.value)}
            >
              <FormControlLabel value="image" control={<Radio />} label="Image" />
              <FormControlLabel value="audio" control={<Radio />} label="Audio" />
              <FormControlLabel value="video" control={<Radio />} label="Video" />
            </RadioGroup>
          </FormControl>
        </div>

        {/* Scheduling Options */}
        <div className="form-group mb-2">
          <FormControl component="fieldset">
            <FormLabel component="legend">Publishing Options</FormLabel>
            <RadioGroup
              row
              value={isScheduled ? "scheduled" : "immediate"}
              onChange={(e) => setIsScheduled(e.target.value === "scheduled")}
            >
              <FormControlLabel value="immediate" control={<Radio />} label="Publish Now" />
              <FormControlLabel value="scheduled" control={<Radio />} label="Schedule Post" />
            </RadioGroup>
          </FormControl>
        </div>

        {/* Schedule Date/Time Input */}
        {isScheduled && (
          <div className="form-group mb-2">
            <Input
              type="datetime-local"
              name="scheduledAt"
              value={scheduledAt}
              onChange={(e) => setScheduledAt(e.target.value)}
              required
              className="form-control"
              label="Schedule Date & Time"
              error={error.scheduledAt}
            />
          </div>
        )}
        {/* Audio Upload - Only for Audio Post Type */}
        {postType === "audio" && (
          <>
            <div className="form-group my-2">
              <Input
                type="file"
                accept="audio/mp3"
                name="musicMedia"
                required
                onChange={(e) => audioHandler(e)}
                placeholder="Upload Music"
                className={`form-control `}
                label={'Upload Music'}
                error={!music && error.music}
              />
            </div>

            {music && (
              <div className="music-player">
                <audio
                  src={music && URL.createObjectURL(music)}
                  controls
                  controlsList="nodownload"
                />
                {musicDuration && (
                  <p style={{ fontSize: '12px', color: '#666', marginTop: '5px' }}>
                    Duration: {musicDuration}
                  </p>
                )}
              </div>
            )}
          </>
        )}

        {/* Video Thumbnail Upload - Only for Video Post Type */}
        {postType === "video" && (
          <div className="form-group my-2">
            <Input
              type="file"
              accept="image/*"
              name="exploreImage"
              onChange={(e) => {
                const file = e.target.files[0];
                if (file) {
                  setExploreImage(file);
                }
              }}
              placeholder="Video Thumbnail Image"
              className={`form-control `}
              label={"Video Thumbnail Image"}
            />
          </div>
        )}

        {/* Media Upload - Conditional based on post type */}
        <div className="form-group my-2">
          <Input
            type="file"
            accept={
              postType === "image" ? "image/*" :
              postType === "audio" ? "image/*" :
              postType === "video" ? "video/*" : "image/*,video/*"
            }
            name="categoryImage"
            multiple={postType === "image" || postType === "audio"}
            required
            onChange={(e) => imageHandler(e)}
            placeholder={
              postType === "image" ? "Upload Images" :
              postType === "audio" ? "Upload Images" :
              postType === "video" ? "Upload Video" : "Upload Media"
            }
            className={`form-control `}
            label={
              postType === "image" ? "Images" :
              postType === "audio" ? "Images" :
              postType === "video" ? "Video" : "Media"
            }
            error={error.image}
          />
        </div>
        
        <div className="form-group mb-2">
          <Select
            name="containerRatio"
            value={selectedContainerRatio}
            onChange={(e) => setSelectedContainerRatio(e.target.value)}
            required
            className="form-control"
            label="Container Ratio "
            error={!selectedContainerRatio && error.containerRatio}
          >
            <option value="">Select Container Ratio</option>
            {containerRatioOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </Select>
        </div>
        <div>
          {image && image.length > 0 && (
            <div style={{ marginTop: '10px' }}>
              <h6 style={{ marginBottom: '10px', color: '#666' }}>
                Selected {postType === "image" ? "Images" : postType === "audio" ? "Images" : "Video"} ({image.length} files)
              </h6>
              {image.map((img, index) => {
                return (
                  <div 
                    key={`${img.name}-${index}`} 
                    style={{ 
                      marginBottom: '15px',
                      position: 'relative',
                      border: '1px solid #ddd',
                      borderRadius: '8px',
                      padding: '10px',
                      backgroundColor: '#f9f9f9'
                    }}
                  >
                    <button
                      onClick={() => removeImage(index)}
                      style={{
                        position: 'absolute',
                        top: '5px',
                        right: '5px',
                        background: '#ff4444',
                        color: 'white',
                        border: 'none',
                        borderRadius: '50%',
                        width: '25px',
                        height: '25px',
                        cursor: 'pointer',
                        fontSize: '12px',
                        zIndex: 10
                      }}
                      title="Remove this file"
                    >
                      ×
                    </button>
                    
                    <div style={{ marginBottom: '5px', fontSize: '12px', color: '#666' }}>
                      {img.name}
                    </div>
                    
                    {videoFileRegex.test(img?.name) && postType === "video" ? (
                      <Fragment>
                        <div className="video-container">
                          <VideoPreview videoUrl={URL.createObjectURL(img)} />
                        </div>

                        <div className="video-thumbnail">
                          <VideoThumbnail
                            videoUrl={URL.createObjectURL(img)}
                            thumbnailHandler={(thumbnail) =>
                              setVideoThumbnail(thumbnail)
                            }
                            renderThumbnail={false}
                            snapshotAtTime={4}
                            width={1080}
                            height={1920}
                          />
                        </div>
                      </Fragment>
                    ) : (
                      <Avatar
                        variant="square"
                        sx={{
                          width: "100%",
                          borderRadius: 1,
                          height: 140,
                          border: "1px solid #FF8989",
                        }}
                        src={img && URL.createObjectURL(img)}
                      />
                    )}
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </ModalBox>
  );
};

export default AddStories;
